import { render, staticRenderFns } from "./sidebarSection.vue?vue&type=template&id=55fef3b8&scoped=true&"
import script from "./sidebarSection.vue?vue&type=script&lang=js&"
export * from "./sidebarSection.vue?vue&type=script&lang=js&"
import style0 from "./sidebarSection.vue?vue&type=style&index=0&id=55fef3b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fef3b8",
  null
  
)

export default component.exports